<template>
  <w-sliding-popup ref="slidingPopup" type="common" title="즐겨찾기" width="470px" :default-content="false" @close="onClose">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <el-button class="add-bookmark mr-b10" type="primary" size="medium" @click="openAddBookmarkPopup(null)"> + 현재 페이지를 즐겨찾기 추가 </el-button>
      <div style="height:calc(100% - 30px)">
        <!-- 즐겨찾기 -->
        <div class="bookmark-wrapper mr-b25" v-loading="isLoading">
          <el-row class="search-tool">
            <div class="vertical-center-box">
              <w-search-field class="mr-r4" ref="searchField" @search="filterTree" />
              <el-button @click="editBookmarkPopup"><i class="fas fa-cog"></i></el-button>
            </div>
          </el-row>
          <div class="tree-wrapper">
            <el-scrollbar>
              <el-tree
                class="bookmark-tree tree-w-stroke"
                ref="tree"
                default-expand-all
                :data="treeData"
                :props="defaultProps"
                :node-key="defaultProps.treeKey"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :allow-drop="allowDrop"
                @node-click="clickNode"
              >
                <span class="el-tree-node__label" slot-scope="{ node, data }">
                  <span v-if="data.subType !== 'BOOKMARK'" class="group">{{ data.label }}</span>
                  <span v-else>
                    <i class="bookmark-icon fas fa-bookmark"></i>
                    <span>{{ data.label }}</span>
                  </span>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
        <!-- 자주 방문하는 페이지 -->
        <div>
          <el-row type="flex" class="title-bar" justify="space-between">
            <div class="text-medium" style="font-weight:500">자주 방문하는 페이지</div>
            <div>
              <el-select class="mr-r4" style="width: 120px;" v-model="searchType">
                <el-option key="contain" label="즐겨찾기 포함" value="contain"></el-option>
                <el-option key="except" label="즐겨찾기 제외" value="except"></el-option>
              </el-select>
              <el-select class="mr-r4" style="width: 60px;" v-model="pagingCount">
                <el-option key="10" label="10" value="10"></el-option>
                <el-option key="20" label="20" value="20"></el-option>
                <el-option key="30" label="30" value="30"></el-option>
                <el-option key="40" label="40" value="40"></el-option>
                <el-option key="50" label="50" value="50"></el-option>
              </el-select>
              <el-dropdown trigger="click" @command="deleteFrequentlyPageByDropdown">
                <span class="el-dropdown-link">
                  <i class="c-pointer fas fa-ellipsis-v" style="color:#92959c;"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :disabled="!isExistSelectedItem" command="seletion">
                    선택한 항목 삭제
                  </el-dropdown-item>
                  <el-dropdown-item command="all">전체 방문 기록 삭제</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-row>
          <ul class="frequently-visit-wrapper">
            <li v-for="data in frequentlyPageData" :key="data.path">
              <el-checkbox style="margin-right:5px;" v-model="data.checked"></el-checkbox>
              <i v-if="data.favoriteFlag" class="fas fa-bookmark bookmark-icon"></i>
              <i v-else class="fas fa-plus-circle add-icon" @click="openAddBookmarkPopup(data)"></i>
              <div class="item" @click="routeFrequentlyPage(data)">
                <el-tooltip effect="dark" :content="data.pathDesc">
                  <div class="label-wrapper">
                    <div class="label">{{ data.pathDesc }}</div>
                  </div>
                </el-tooltip>
                <span class="datetime">{{ formatterForDate(data.lastVisitDatetime) }}</span>
              </div>
              <i class="close-button far fa-times" @click="deleteFrequentlyPageByClick(data)"></i>
            </li>
          </ul>
        </div>
      </div>
      <w-add-bookmark-popup ref="addBookmarkPopup" @reload="reload" :addTargetBookmark="addTargetBookmark"></w-add-bookmark-popup>
      <w-edit-bookmark-popup ref="editBookmarkPopup" @reload="reload"></w-edit-bookmark-popup>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, cloneDeep, isEmpty } from 'lodash';
import TreeFilter from '@/mixins/tree/filter';
import BookmarkAPI from '@/api/frame/bookmark';
import WSearchField from '@/components/form/SearchField';
import { routeByPathAfterCheckValid } from '@/utils/router';
import { defaultProps } from '@/constants/tree';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import DragTreeMixin from '@/views/chart/components/tree/mixins/drag-tree';
import WAddBookmarkPopup from './AddBookmarkPopup';
import WEditBookmarkPopup from './EditBookmarkPopup';

export default {
  name: 'WBookmarkPopup',
  components: {
    WSearchField,
    WAddBookmarkPopup,
    WEditBookmarkPopup,
  },
  mixins: [TreeFilter, DragTreeMixin],
  data() {
    return {
      routeByPathAfterCheckValid,
      defaultProps,
      isLoading: false,
      addTargetBookmark: null,
      selectedData: null,
      frequentlyPageData: null,
      treeRef: 'tree',
      // 즐겨찾기 조회시 검색 조건
      searchType: 'contain',
      pagingCount: 10,
      treeData: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    showFavoritePopup() {
      return this.$store.state.popup.showFavoritePopup;
    },
    isExistSelectedItem() {
      return !isNil(this.frequentlyPageData) && this.frequentlyPageData.filter((item) => item.checked).length > 0;
    },
  },
  watch: {
    showFavoritePopup: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
    pagingCount: {
      handler(value) {
        if (!isNil(value)) {
          this.getFrequentlyPageList();
        }
      },
      immediate: true,
    },
    searchType: {
      handler(value) {
        if (!isNil(value)) {
          this.getFrequentlyPageList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.searchType = 'contain';
      this.pagingCount = 10;
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    onClose() {
      this.searchType = null;
      this.pagingCount = null;
      this.$refs.searchField.clear();
      if (this.showFavoritePopup) {
        this.$store.dispatch('closeFavoritePopup');
      }
    },
    /**
     * 계정에 따른 즐겨찾기 목록을 조회한다.
     * @author yelim
     * @return {[type]} [description]
     */
    loadData() {
      this.isLoading = true;
      BookmarkAPI.getBookmarkTree({
        searchGroupFlag: false,
      })
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            if (!isEmpty(result) && !isEmpty(result[0].children)) {
              result[0].children.sort((a, b) => a.orderbyIndex - b.orderbyIndex);
            }
            this.treeData = result;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 목록', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 목록', false));
          throw new Error(e);
        }).finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * Bookmark node를 선택하는 경우 라우터를 제공한다.
     * @author yelim
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    clickNode(node) {
      if (node.subType === 'BOOKMARK') {
        routeByPathAfterCheckValid(this, node.bookmarkInfo.bookmarkPath, () => {
          this.$confirm(...msgUtil.getCustomConfirmData('선택한 경로가 삭제되어 이동할 수 없습니다. 자주 방문하는 페이지에서 삭제하시겠습니까?')).then(() => {
            // bookmark table delete
            const deleteInfo = {
              bookmarkId: node.bookmarkInfo.bookmarkId,
              menuId: node.bookmarkInfo.menuId,
              managetypeId: node.bookmarkInfo.managetypeId,
            };
            BookmarkAPI.deleteBookmarkInfo([deleteInfo])
              .then((response) => {
                if (response.data.success) {
                  this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '즐겨찾기', true));
                  this.loadData();
                } else {
                  this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '즐겨찾기', false));
                }
              })
              .catch((e) => {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '즐겨찾기', false));
                throw new Error(e);
              });
          });
        });
        this.onClose();
      }
    },
    /**
     * 자주 방문하는 페이지 목록을 조회한다.
     * @author yelim
     * @return {[type]} [description]
     */
    getFrequentlyPageList() {
      const userId = this.userInfo.managerId;
      const params = {
        managerId: userId,
        start: 0,
        limit: this.pagingCount,
        searchType: this.searchType,
      };
      BookmarkAPI.getFrequentlyPageList(params)
        .then((response) => {
          if (response.data.success) {
            this.frequentlyPageData = response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기', false));
          throw new Error(e);
        });
    },
    /**
     * 날짜 formatter
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    formatterForDate(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 즐겨찾기 추가 팝업을 연다.
     * @author yelim
     * @return {[type]} [description]
     */
    openAddBookmarkPopup(row) {
      if (!isNil(row)) {
        this.addTargetBookmark = {
          bookmarkName: row.pathDesc,
          pathDesc: row.pathDesc,
          path: row.path,
        };
      } else {
        this.addTargetBookmark = {
          bookmarkName: this.$store.getters.navigationPathLabel,
          pathDesc: this.$store.getters.navigationPathLabel,
          path: this.$route.path,
        };
      }
      this.$refs.addBookmarkPopup.open();
    },
    editBookmarkPopup() {
      this.$refs.editBookmarkPopup.open();
    },
    reload() {
      this.loadData();
      this.getFrequentlyPageList();
    },
    /**
     * 자주 방문하는 페이지를 dropdown에서 선택한 항목에 맞추어 삭제한다.
     * @author yelim
     * @param  {[type]} command [description]
     * @return {[type]}         [description]
     */
    deleteFrequentlyPageByDropdown(command) {
      const params = [];
      const deleteParams = {
        pathList: params,
      };
      if (command !== 'all') {
        // 그리드에서 선택한 항목만 삭제
        if (!isEmpty(this.frequentlyPageData)) {
          const selectionList = this.frequentlyPageData.filter((item) => item.checked);
          selectionList.forEach((selectInfo) => {
            params.push({
              path: selectInfo.path,
            });
          });
        }
      } else {
        deleteParams.checkCommand = 'ALL';
      }
      this.$confirm(...msgUtil.getCustomConfirmData('삭제하시겠습니까?')).then(() => {
        this.deleteVisitPage(deleteParams);
      });
    },
    /**
     * 선택한 row의 자주 방문하는 페이지 항목을 삭제한다.
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    deleteFrequentlyPageByClick(row) {
      const pathInfo = {
        path: row.path,
      };
      const deleteParams = {
        pathList: [pathInfo],
      };
      this.deleteVisitPage(deleteParams);
    },
    deleteVisitPage(params) {
      BookmarkAPI.deleteFrequentlyPage(params)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '자주 방문하는 페이지', true));
            this.reload();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '자주 방문하는 페이지', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '자주 방문하는 페이지', false));
          throw new Error(e);
        });
    },
    routeFrequentlyPage(row) {
      routeByPathAfterCheckValid(this, row.path, () => {
        this.$confirm(...msgUtil.getCustomConfirmData('선택한 경로가 삭제되어 이동할 수 없습니다. 자주 방문하는 페이지에서 삭제하시겠습니까?')).then(() => {
          // bookmark table delete
          this.deleteFrequentlyPageByClick(row);
        });
      });
      this.onClose();
    },
  },
};
</script>

<style lang="scss">
$box-border-color: #dcdfe6;
.bookmark-wrapper {
  .el-scrollbar {
    //16/mar/20
    height: 29vh;
    min-height: 242px;
    .el-scrollbar__wrap {
      //for ie & firefox 16/mar/20
      margin-bottom: 0 !important;
      height: 96%
    }
  }
  min-height: 300px;
  height: 34vh;
  border: 1px solid $box-border-color;
  border-radius: 5px;
  .el-input__inner, .el-button--default {border: 1px solid $box-border-color}
  .el-tree-node__content {padding: 2px 0; display: flex;}
  .el-tree-node.is-expanded>.el-tree-node__children {display: block; padding: 1px 0}
  .search-tool {
    padding: 7px 10px;
    background: #f5f7fa;
    border-bottom: 1px solid $box-border-color;
  }

  .tree-wrapper {
    padding: 5px 15px 15px;
  }
}

.frequently-visit-wrapper {
  width: 100%;
  border-top: 1px solid $box-border-color;

  & > li {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    font-weight: 400;
    font-size: 12px;
    font-family: 'NunitoSans', 'Malgun Gothic', sans-serif;
    line-height: 25px;
    padding: 4px;
    border-bottom: 1px solid #f4f4f4;
    &:hover {background: #eef5ff}

    .add-icon {
      color: #b7c1ca;
      cursor: pointer;
      margin-right: 8px;
    }

    .bookmark-icon {
      color: #2b68be;
      margin-right: 8px;
    }

    .close-button {
      position: absolute;
      right: 0;
      top: 0;
      display: none;
      background: #f6f6f7;
      cursor: pointer;
      padding: 10px;
    }

    &:hover .close-button {
      display: inline;
    }

    .item {
      align-items: center;
      display: flex;
      flex: 1;
      overflow: hidden;
      cursor: pointer;

      .label-wrapper {
        align-items: center;
        display: flex;
        overflow: hidden;
        text-decoration: none;

        .label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .datetime {
        flex-shrink: 0;
        margin-inline-start: 10px;
        color: #b7b5b3;
        font-size: 12px;
      }
    }
  }
}

.el-button.add-bookmark {
  $bg-color: linear-gradient(145deg, #5575fe, #1590ee);
  $font-color: #fff;
  background: $bg-color;
  color: $font-color;
  font-size: 14px;
  width: 100%;
  height: 38px;
  line-height: 40px;
  border: 0;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  z-index: 9;
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  &:after,
  &:before {
    content: '';
    position: absolute;
    z-index: -2;
    transition-property: inherit;
    transition-duration: inherit;
    transition-timing-function: inherit;
    border-radius: 5px;
    width: 0;
    height: 100%;
    top: 0;
    left: 100%;
    background: rgba(255, 255, 255, 0.1);
  }
  &:before {
    z-index: -1;
    background: $bg-color;
  }
  &:after {
    background: rgba(255, 255, 255, 0.1);
    transition-delay: 0.1s;
  }
  &:hover:before {
    width: 100%;
    left: 0;
    transition-property: width;
    transition-delay: 0.1s;
  }
  &:hover:after {
    width: 100%;
    left: 0;
    transition-property: width;
    transition-delay: 0s;
  }

  &:focus {
    color: $font-color;
    background: $bg-color;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/BookmarkPopup.vue